import React from 'react'
// import action from './action'

const ItemTypes = {
  'action.button': require('./action-button'),
  // 'action': require('./action'),
  // 'action': action,
  'input': require('./input'),
  'input.file': require('./input-file'),
  'input.dropzone': require('./input-dropzone'),
  'select': require('./select'),
  'select.radio': require('./select-radio'),
  'select.checkbox': require('./select-checkbox'),
  'display': require('./display'),
  'todo-item-type': require('./todo-item-type'),
  // 'select.search'  : require('./todo-item-type'),
  // 'picker.year'  : require('./todo-item-type'),
  // 'picker.date'  : require('./todo-item-type'),
}

/**
 * Add an item type
 * See playground sample for usage
 * @param  type      name     Name of ItemType
 * @param  Component instance Item Type Component
 */

ItemTypes.addItemType = (name, instance) => {
  if (typeof name !== 'string') {
    throw new Error('Flow Conductor: First parameter of addItemType '
                    + 'must be of type string')
  }
  if (!(React.Component instanceof instance.constructor)) {
    throw new Error(`Flow Conductor: Cannot not assign ${name} as an ItemType. `
                    + 'Second paramter expects a React component')
  }
  ItemTypes[name] = instance;
}

/**
 * Add multiple ItemTypes
 * See playground sample for usage
 * @param  object types ItemTypes to add. string => Component
 */
ItemTypes.addItemTypes = (types) => {
  if (typeof types !== 'object') {
    throw new Error('Flow Conductor: First parameter of addItemTypes '
                    + 'must be of type object');
  }
  for (var type in types) {
    ItemTypes.addInputType(type, types[type]);
  }
}

module.exports = ItemTypes



// WEBPACK FOOTER //
// ./item-types/index.js